import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
 import { DASHBOARD } from "../utils/RouteConstant";

const PublicRoutes = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      navigate(DASHBOARD);
    }
  }, [navigate]);
  return children;
};

export default PublicRoutes;
